import { LabelModel } from '@/models/label.model'
import { api } from '@/services/api'

export type CreateLabelResponse = {
  label: LabelModel
}

export async function create(params: Omit<LabelModel, 'id' | 'createdAt' | 'updatedAt'>) {
  const response = await api.post<CreateLabelResponse>('/labels', params)
  return response.data
}

export type UpdateLabelResponse = {
  label: LabelModel
}

export async function update(labelId: string, dataToUpdate: Partial<LabelModel>) {
  const response = await api.put<UpdateLabelResponse>('/labels', {
    labelId,
    dataToUpdate
  })
  return response.data
}

export async function deleteLabel(labelId: string) {
  await api.delete(`/labels/${labelId}`)
}

export type FetchLabelsByCompanyAndOperatorResponse = {
  labels: LabelModel[]
}

export async function fetchLabelsByCompanyAndOperator(companyId: string, operatorId?: string) {
  const response = await api.get<FetchLabelsByCompanyAndOperatorResponse>(`/labels/by-company-and-operator`, {
    params: { companyId, operatorId }
  })
  return response.data
}
